const facilities = [
    {
        name: 'vacuum-system',
        primaryPic: 'facility1.jpg',
        title: 'High Vacuum In-situ Growth and Characterization System',
        content: [
            `
            This is a home-built cryogenic in-situ growth and characterization system designed and fabricated by the Functional Materials Studio (Lei’s Lab). The system interconnects an ultra-high-vacuum deposition chamber (equipped with Augur, LEED, mass spectrometer, and multiple atom/ion sources), and an inverted high-vacuum probe station(with six low-noise probes, several optical access, and magnetic field (which is currently under upgrading to 3T)).  The instrument facilitates the in-situ characterization of the surface states of low-dimensional materials, and more importantly, allows the transport, electronic and optoelectronic measurement free of ambient degradation or contamination with the cooperation of our various measurement instruments and light sources. 
            `,
        ]
    },
    {
        name: 'laser-system',
        primaryPic: 'facility2.jpg',
        title: 'Ultra-fast Laser System',
        content: [
            `
            The ultra-fast laser system consists of Verdi V5 532 nm pump laser, Mira 900 oscillator, galvanometer scanner, and Nikon microscope. The system provides the light source for the projects of two-photon polymerization, two-photon fluorescence imaging for 3D material structure reconstruction. It will also serve as the light source for the pump-probe experiment and supercontinuum generation (which are under construction and will be integrated with the probe station.)
            `,
        ]
    },
    {
        name: 'raman',
        primaryPic: 'facility3.jpg',
        title: 'Confocal Raman Microscope',
        content: [
            `
            Home-built confocal Raman system equipped with tunable Argon ion laser (514.5 nm, 501.7 nm, 496.5 nm, 488.0 nm, 476.5 nm, 457.9 nm), Andor Shamrock 500i imaging spectrometer, and Andor iDus TE cooling CCD array. The system can be independently operated or combined with the probe-station for temperature-dependent in-situ Raman measurement.   
            `,
        ]
    },
    {
        name: 'fabrication-system',
        primaryPic: 'something.jpg',
        title: 'Two-photon Polymerization 3D Microstructure Fabrication System',
        content: [
            `
            Home-built two-photon polymerization system for 3D microstructure fabrication with micro-scale spatial resolution. Our ultrafast laser system serve as the light source. This system will help us to investigate complex microstructures and devices for energy harvest, sensing, energy storage, etc. 
            `,
        ]
    },
    {
        name: 'printing-system',
        primaryPic: 'facility4.jpg',
        title: 'Visible Laser Ceramics 3D Printing System',
        content: [
            `
            The selective laser sintering/melting system composed of Verdi V5 532 nm laser for functional ceramic 3D printing. Under low-power mode, the system can collaborate with the Raman system for in-situ sample characterization to study the laser sintering process and control the sample quality. (The system is currently moving to our new location!
            `,
        ]
    },
    {
        name: 'synthesis',
        primaryPic: 'facility5.jpg',
        title: 'Materials Synthesis Facilities',
        content: [
            `
            Our Functional Material Studio is equipped with multiple material preparation and growth facilities to meet the requirement of high-quality material for our internal research and collaborations. 
            `,
        ]
    },
    {
        name: 'device',
        primaryPic: 'home.jpg',
        title: 'Device Fabrication Facilities',
        content: [
            `
            empty
            `,
        ]
    },
    // {
    //     name: 'AFM',
    //     primaryPic: 'AFM.jpg',
    //     title: 'Atomic Force Microscope',
    //     content: [
    //         `
    //         empty
    //         `,
    //     ]
    // },

    
];

export default facilities;